import { ShareDataWrapperContext } from '@/pages/WgqAllMaps';
import { Button, DatePicker, Dropdown, Empty, message } from '@maxtropy/components';
import { Space } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import CardBox from '../../../CardBox';
import SwitchDate from './components/SwitchDate';
import styles from './index.module.scss';
import WaterUsageOverview from './WaterUsageOverview';
import { useRequest } from 'ahooks';
import { apiV2WaterMapDataCardDataPost } from '@maxtropy/device-customer-apis-v2';
import { keepTwoOrLine } from '@/utils/utils';
import CenterTopBox from '../CenterTopBox';
import { DoubleRightOutlined } from '@ant-design/icons';
import { ShareConfigDataWaterContext } from '../..';
import { getDefaultTimeByWaterTrend } from '@/pages/WgqAllMaps/utils';
import { isNil } from 'lodash-es';

const RangePicker = DatePicker.RangePicker;

export type RangeValue = Dayjs | null;

// 时间颗粒度（水的成本趋势）
export enum DateTypeByWater {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export const DateTypeByWaterDisplay = {
  [DateTypeByWater.MONTH]: '按月',
  [DateTypeByWater.YEAR]: '按年',
};

interface ShareWaterDataProps {
  value?: RangeValue;
  timeResolution?: DateTypeByWater;
}

export const ShareDataWaterMapContext = createContext<ShareWaterDataProps>({});

const LeftBox = () => {
  const { loadMap } = useContext(ShareDataWrapperContext);
  const isNoMapLayout = !loadMap;
  const { configDetail } = useContext(ShareConfigDataWaterContext);
  const [timeResolution, setTimeResolution] = useState<DateTypeByWater>(DateTypeByWater.MONTH);
  const [value, setValue] = useState<RangeValue>();

  useEffect(() => {
    // 如果当前是1号，则默认时间为上个月
    const date = dayjs().date() === 1 ? dayjs().subtract(1, 'day') : dayjs();
    setValue(date);
  }, []);

  // 地图卡片
  const { data: cardData, loading } = useRequest(async () => {
    return await apiV2WaterMapDataCardDataPost({});
  });

  const isEmpty = useMemo(() => {
    return !cardData || cardData.list?.length === 0;
  }, [cardData]);

  console.log('value', value);

  const energyStr = useMemo(() => {
    let str = '';
    if (!isNil(configDetail?.energyGroupId1)) {
      str += `energyGroupId=${configDetail?.energyGroupId1}`;
    }
    if (!isNil(configDetail?.energyUnitId1)) {
      str += `${str ? '&' : ''}unitId=${configDetail?.energyUnitId1}`;
    }
    return str;
  }, [configDetail]);

  const routeStr = useMemo(() => {
    if (!timeResolution || !value) return '';

    if (timeResolution === DateTypeByWater.YEAR) {
      const startDate = dayjs(getDefaultTimeByWaterTrend(timeResolution, value).startTime).format('YYYY');
      const endDate = dayjs(getDefaultTimeByWaterTrend(timeResolution, value).endTime).format('YYYY');
      return `&currentYear=true&startDate=${startDate}&endDate=${endDate}`;
    }

    const startDate = dayjs(getDefaultTimeByWaterTrend(timeResolution, value).startTime).format('YYYYMM');
    const endDate = dayjs(getDefaultTimeByWaterTrend(timeResolution, value).endTime).format('YYYYMM');

    return `&currentYear=false&currentMonth=true&startDate=${startDate}&endDate=${endDate}`;
  }, [timeResolution, value]);

  return (
    <ShareDataWaterMapContext.Provider value={{ timeResolution, value }}>
      {!loadMap && (
        <div className={styles.row}>
          <CenterTopBox fixLeft={true} />
        </div>
      )}

      <CardBox
        title="用水概况"
        className={isNoMapLayout ? styles.card_content_no_map : ''}
        style={{
          height: isNoMapLayout ? 'auto' : undefined,
        }}
        extraContent={
          <Space size={8}>
            <Dropdown
              type="link"
              className={styles.dropdown_wrapper}
              getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
              trigger={['click']}
              dropdownRender={() => (
                <div className={styles.dropdown_menu_wrapper}>
                  <SwitchDate
                    activeKey={timeResolution}
                    value={value}
                    setActiveKey={setTimeResolution}
                    setValue={setValue}
                  />
                </div>
              )}
            >
              {dayjs(value).format(timeResolution === DateTypeByWater.MONTH ? 'YYYY-MM' : 'YYYY')}
            </Dropdown>
            <Button
              style={{ padding: 0 }}
              type="link"
              onClick={() => {
                window.open(`/energy/usageCost/kanban?${energyStr}${routeStr}`, '_blank');
              }}
            >
              <DoubleRightOutlined className="translationStyles" />
            </Button>
          </Space>
        }
      >
        <WaterUsageOverview />
      </CardBox>
    </ShareDataWaterMapContext.Provider>
  );
};

export default LeftBox;
